import { createFileRoute } from "@tanstack/react-router";

import { DocxEditorPage } from "@/features/docx-editor/components/docx-editor-page";

export const Route = createFileRoute("/_authed/documents/$fileId/edit")({
  component: DocxEditorRoute,
});

function DocxEditorRoute() {
  const { fileId } = Route.useParams();
  return <DocxEditorPage fileId={fileId} />;
}
